import { http, baseURL } from '@/api/httpAxios'
import { AxiosPromise } from 'axios'
import { User } from 'interfaces/user'
import { authBase, authDevBase, isProduction } from '@/config/urls'

export class UserAPI {
  public static getCurrentUser(
    reload = false
  ): AxiosPromise<{ user: User | null }> {
    const params = new URLSearchParams()
    if (reload) {
      params.append('reload', 'true')
    }
    return http.get('/auth/current-user', { params })
  }

  public static login(role: string, redirect?: string) {
    let redirectLink = ''

    if (isProduction) {
      redirectLink =
        authBase + (redirect ? `?redirect=${encodeURIComponent(redirect)}` : '')
    } else {
      // Dev
      redirectLink = `${authDevBase}?userId=1`
    }

    window.location.href = redirectLink
  }

  public static fakeLogout() {
    if (isProduction) {
      window.location.href = `${baseURL}/auth`
    } else {
      window.location.href = `${baseURL}/auth/dev`
    }
  }

  public static changeUser(userId: number) {
    window.location.href = `${baseURL}/auth/${
      isProduction ? 'view' : 'dev'
    }?userId=${userId}`
  }

  public static logout() {
    return http.get('/auth/logout')
  }
}
